module.exports = __webpack_public_path__ + "images/embed/icons/aim_icon.png";